import restaurantDiningRoomApi from '../../api/restaurant/restaurantDiningRoomApi';
import {
  CustomResponse,
  RestaurantDiningRoomDTO,
  RestaurantDiningRoomFilters,
  RestaurantDiningRoomPage,
  RestaurantDiningRoomForm,
} from '../../types/restaurant/RestaurantDiningRoomTypes';

const payload = (form: RestaurantDiningRoomForm) => ({
  name: form.name.trim(),
  description: form.description.trim() || null,
  displayOrder: Number(form.displayOrder),
  ...(form.id ? { active: form.active } : {}),
});

const RestaurantDiningRoomService = {
  listFiltered: async (
    branchId: number,
    filters: RestaurantDiningRoomFilters
  ) => {
    const query = new URLSearchParams({
      page: String(filters.page),
      size: String(filters.size),
    });
    query.append('sort', 'displayOrder,asc');
    query.append('sort', 'name,asc');
    const response = await restaurantDiningRoomApi.addCustom(
      `/branches/${branchId}/filtered?${query.toString()}`,
      {
        search: filters.search?.trim() || null,
        active: filters.active,
      }
    );
    return response.data as RestaurantDiningRoomPage;
  },
  list: async (branchId: number, activeOnly = false) => {
    const response = await restaurantDiningRoomApi.fetchCustom(
      `/branches/${branchId}?activeOnly=${activeOnly}`
    );
    return response.data as CustomResponse<RestaurantDiningRoomDTO[]>;
  },
  get: async (id: number) => {
    const response = await restaurantDiningRoomApi.fetchById(id);
    return response.data as CustomResponse<RestaurantDiningRoomDTO>;
  },
  create: async (branchId: number, form: RestaurantDiningRoomForm) => {
    const response = await restaurantDiningRoomApi.addCustom(
      `/branches/${branchId}`,
      payload(form)
    );
    return response.data as CustomResponse<RestaurantDiningRoomDTO>;
  },
  update: async (id: number, form: RestaurantDiningRoomForm) => {
    const response = await restaurantDiningRoomApi.modify(id, payload(form));
    return response.data as CustomResponse<RestaurantDiningRoomDTO>;
  },
  deactivate: async (id: number) => {
    const response = await restaurantDiningRoomApi.remove(id);
    return response.data as CustomResponse<null>;
  },
};

export default RestaurantDiningRoomService;
